module.exports = __webpack_public_path__ + "static/media/icon-cartoon-thunder.7e5ccd21.svg";